"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapProductBoxesFromStaticApi = void 0;
var _mapProductBoxPropsFromStaticApi = require("./mapProductBoxPropsFromStaticApi");
const mapProductBoxesFromStaticApi = ({
  data,
  isAnonymousUser,
  mode,
  overrides
}) => data.filter(product => product !== null).map(product => (0, _mapProductBoxPropsFromStaticApi.mapProductBoxPropsFromStaticApi)({
  data: product,
  overrides,
  mode,
  isAnonymousUser
})).filter(product => product !== null);
exports.mapProductBoxesFromStaticApi = mapProductBoxesFromStaticApi;
//# sourceMappingURL=mapProductBoxesFromStaticApi.js.map